export const STEPS = {
  BASIC_INFORMATION: "BASIC_INFORMATION",
  JOB_DETAILS: "JOB_DETAILS",
  TEAM_MANAGEMENT: "TEAM_MANAGEMENT",
  CONFIRMATION: "CONFIRMATION",
};

export const STAFFING_AGENCIES_REPORT_FILTERS = {
  AGENCIES: "agencies",
  JOBS: "jobs",
  PERIOD: "period",
  RESET: "reset",
};

export const COMPENSATION_TYPES = {
  HOURLY: "hourly",
  MONTHLY: "monthly",
  YEARLY: "yearly",
  AVERAGE: "specific",
  RANGE: "range",
};

export const COMPENSATION_TYPE_LABELS = {
  HOURLY: "Per Hour",
  MONTHLY: "Per Month",
  YEARLY: "Per Year",
};

export const LOCATION_TYPES = {
  HYBRID: "hybrid",
  IN_PERSON: "in person",
  REMOTE: "remote",
};

export const PAY_RATE_CURRENCIES = {
  USD: "usd",
};

export const PAY_RATE_CURRENCY_LABELS = {
  USD: "USD",
};

export const JOB_HOURS_TYPES = {
  PART_TIME: "part_time",
  FULL_TIME: "full_time",
};

export const CONVERSION_DESCRIPTIONS = {
  YES: "Yes",
  NO: "No",
};

function getSalaryBoundary(type, boundary) {
  return HA_BUSINESS_CONF.RANGE_SALARY_BOUNDARIES_CENTS[type][boundary] / 100;
}

export const HOUR_RANGE = {
  MIN: getSalaryBoundary("hour", "min"),
  MAX: getSalaryBoundary("hour", "max"),
};

export const MONTH_RANGE = {
  MIN: getSalaryBoundary("month", "min"),
  MAX: getSalaryBoundary("month", "max"),
};

export const YEAR_RANGE = {
  MIN: getSalaryBoundary("year", "min"),
  MAX: getSalaryBoundary("year", "max"),
};
